import { render, staticRenderFns } from "./BodySingleDataCard.vue?vue&type=template&id=2d0d531a"
import script from "./BodySingleDataCard.vue?vue&type=script&lang=js"
export * from "./BodySingleDataCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports